import { CatalogObjectVariantsOption } from './CatalogObjectVariantsOption';

export interface ICatalogObjectVariantsInfo {
  title: string;
  options: CatalogObjectVariantsOption[];
}

export class CatalogObjectVariantsInfo
implements ICatalogObjectVariantsInfo {
  title: string = '';
  options: CatalogObjectVariantsOption[] = [];
}
